import { createContext, useContext, useReducer, useEffect } from 'react'

const CartContext = createContext()

const initialState = {
  items: [],
  labLocation: null,
}

function cartReducer(state, action) {
  switch (action.type) {
    case 'ADD_ITEM': {
      const existingItem = state.items.find(item => item._id === action.payload._id)
      if (existingItem) {
        return state
      }
      // Ensure price fields are set
      const item = {
        ...action.payload,
        ourPrice: action.payload.ourPrice || action.payload.price || 0,
        retailPrice: action.payload.retailPrice || (action.payload.ourPrice * 1.5) || 0
      }
      return {
        ...state,
        items: [...state.items, item],
      }
    }
    case 'REMOVE_ITEM':
      return {
        ...state,
        items: state.items.filter(item => item._id !== action.payload),
      }
    case 'SET_LAB_LOCATION':
      return {
        ...state,
        labLocation: action.payload,
      }
    case 'CLEAR_CART':
      return initialState
    case 'LOAD_CART':
      return {
        ...initialState,
        ...action.payload,
        items: action.payload?.items || []
      }
    default:
      return state
  }
}

export function CartProvider({ children }) {
  const [state, dispatch] = useReducer(cartReducer, initialState)

  // Load cart from localStorage on mount
  useEffect(() => {
    const savedCart = localStorage.getItem('chatwithdr-cart')
    if (savedCart) {
      try {
        const parsed = JSON.parse(savedCart)
        dispatch({ type: 'LOAD_CART', payload: parsed })
      } catch (e) {
        console.error('Failed to load cart:', e)
      }
    }
  }, [])

  // Save cart to localStorage on change
  useEffect(() => {
    localStorage.setItem('chatwithdr-cart', JSON.stringify(state))
  }, [state])

  const addToCart = (test) => {
    dispatch({ type: 'ADD_ITEM', payload: test })
  }

  const removeFromCart = (testId) => {
    dispatch({ type: 'REMOVE_ITEM', payload: testId })
  }

  const setLabLocation = (location) => {
    dispatch({ type: 'SET_LAB_LOCATION', payload: location })
  }

  const clearCart = () => {
    dispatch({ type: 'CLEAR_CART' })
    localStorage.removeItem('chatwithdr-cart')
  }

  const isInCart = (testId) => {
    return state.items.some(item => item._id === testId)
  }

  const cartTotal = state.items.reduce((total, item) => total + (item.ourPrice || item.price || 0), 0)
  const cartCount = state.items.length

  const value = {
    items: state.items,
    labLocation: state.labLocation,
    cartTotal,
    cartCount,
    addToCart,
    removeFromCart,
    setLabLocation,
    clearCart,
    isInCart,
  }

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  )
}

export function useCart() {
  const context = useContext(CartContext)
  if (!context) {
    throw new Error('useCart must be used within a CartProvider')
  }
  return context
}
